import { Box, useMediaQuery, useTheme } from "@mui/material";
import React, { ReactNode } from "react";
import { SubscriptionExpiryBanner } from "../SubscriptionExpiryBanner";
import MobileWarning from "./MobileWarning";
import { useAuth } from "../../contexts/AuthContext";

interface MobileDetectionWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that detects mobile devices and shows a warning message
 * instead of the main application content.
 *
 * Desktop threshold: 768px (md breakpoint)
 * - Desktop/Laptop (≥768px): Shows children (main app)
 * - Tablet/Mobile (<768px): Shows MobileWarning component
 */
const MobileDetectionWrapper: React.FC<MobileDetectionWrapperProps> = ({
  children,
}) => {
  const theme = useTheme();
  const { user } = useAuth();
  // Detect screens smaller than 768px (md breakpoint)
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Show warning on mobile/tablet devices
  if (isMobile) {
    return <MobileWarning />;
  }

  // Show normal app content on desktop with banner
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <SubscriptionExpiryBanner
        expiryDate={user?.access_expires_at || null}
        accountStatus={user?.account_status}
      />
      <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>{children}</Box>
    </Box>
  );
};

export default MobileDetectionWrapper;
